'use strict';

/**
 * View for rendering a single talk/contact/group in drag and drop mode
 *
 * @category   View
 * @module     entities
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');
var template = require('../../templates/partials/navigation-talks-dnd-list-item.hbs');

var NavigationTalksDndListItemView = ItemView.extend({
    template: template,
    tagName: 'li',
    attributes: function() {
        return {
            'data-id': this.model.id,
        }
    },

    onRender: function() {
        ItemView.prototype.onRender.apply(this, arguments);

        this.$el.humansDrop({
            overClass: 'drop-target-over',
            accept: '.box-object-set',
            onDrop: this.itemDropped.bind(this),
            onOver: function(event, humansDrop, humansDrag, element) {
                $('#nav').addClass('has-drag-inside');
            },
            onLeave: function(event, humansDrop, humansDrag, element) {
                $('#nav').removeClass('has-drag-inside');
            },
        });
    },

    /**
     * Is called, when a set gets dropped
     * @param event
     * @param humansDrop
     * @param humansDrag
     * @param element
     */
    itemDropped: function(event, humansDrop, humansDrag, element) {
        var setId    = humansDrag.getTargetElement().data('id');
        var catalog = App.CollectionModule.catalogs.getActiveCatalog();
        var setModel = catalog.sets.get(setId)
        var action = setModel.isShared() ? 'resolve:share:url' : 'share:set';

        App.radio('collection:set').execute(action, catalog, setId, {
            success: function(url) {
                if (url) {
                    var conversation = this.model.get('conversation');
                    var message      = {
                        type: 'text',
                        data: url,
                    };

                    // Show notification to user
                    this.showNotification(action, setModel, conversation, message);
                }
            }.bind(this),
        });
    },

    /**
     * Sends the notification to the user
     * @param {string} action       The action
     * @param {Object} setModel     The set model
     * @param {Object} conversation The conversation model
     * @param {Object} message      The message to send
     */
    showNotification: function(action, setModel, conversation, message) {
        App.radio('community').execute('send:message:to:conversation', conversation, message, {
            success: function() {
                var catalog = setModel.collection.catalog;

                var setLink = App.html.link({
                    url: '/catalogs/' + catalog.id + '/sets/' + setModel.id,
                    label: '»' + _.escape(setModel.get('name').trim()) + '«',
                });

                var talkLink = App.html.link({
                    url: this.model.get('conversationUrl'),
                    label: '»' + _.escape(this.model.get('name').trim()) + '«',
                });

                // Determine translation key
                var translationKey = action === 'share:set'
                                   ? 'community::share-set:message-shared-'
                                   : 'community::share-set:message-default-';

                Messenger().info({
                    message: App.t(translationKey + conversation.get('type'), {
                        setName: setLink,
                        name: talkLink,
                    }),
                });

                // Trigger change on model
                this.model.trigger('change');
            }.bind(this),
        });
    },
});

module.exports = NavigationTalksDndListItemView;